import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {Export} from '../../Models/Export';
import {ExportService} from '../../Services/export.service';
import {environment} from '../../../../environments/environment';
import {DealerProfileService} from '../../Services/dealer-profile.service';
import {ContactFunctionService} from '../../Services/contact-function.service';
import {BackOfficeOrderService} from '../../Services/order.service';
import {HttpParams} from '@angular/common/http';

@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.scss']
})
export class ExportComponent implements OnInit {
  public entities = [];
  public exportType: Export = new Export();
  public baseUrl = environment.apiUrl;
  @ViewChild('downloadLink', {static: true}) downloadLink: ElementRef;
  contactFunctionItems: any[];
  selectedContactFunction = null;
  dealerProfileItems: any[];
  selectedDealerProfile = null;

  constructor(
    private exportService: ExportService,
    private dealerProfileService: DealerProfileService,
    private contactFunctionService: ContactFunctionService,
    private orderService: BackOfficeOrderService,
  ) {
  }

  ngOnInit() {
    const models = ['Dealers', 'Fabrics', 'Models', 'Options', 'Products', 'Orders per supplier', 'Emails', 'Orderbook', 'Parts'];
    const today = new Date();
    this.exportType.entity = 'Dealers';
    // set default export date for previous month
    this.exportType.from = {day: today.getDate(), month: today.getMonth(), year: today.getFullYear()};
    this.exportType.to = {day: today.getDate(), month: today.getMonth() + 1, year: today.getFullYear()};
    models.forEach(model => {
      this.entities.push(model);
    });
    this.getProfiles();
    this.getContactFunctions();
  }

  getProfiles() {
    this.dealerProfileService.getProfiles().subscribe(resp => {
      this.dealerProfileItems = resp.data.map(item => ({label: item.name, value: item.id}));
    });
  }

  getContactFunctions() {
    this.contactFunctionService.getContactFunctions().subscribe(resp => {
      this.contactFunctionItems = resp.data.map(item => ({label: item.title, value: item.id}));
    });
  }

  export() {
    const exportType = JSON.parse(JSON.stringify(this.exportType));

    if (exportType.from) {
      const dFrom = <{ from: string }>exportType.from.day;
      const mFrom = <{ from: string }>exportType.from.month;
      const yFrom = <{ from: string }>exportType.from.year;
      if (typeof yFrom !== 'undefined' && typeof mFrom !== 'undefined' && typeof dFrom !== 'undefined') {
        exportType.from = yFrom + '-' + mFrom + '-' + dFrom;
      }
    }
    if (exportType.to) {
      const dTo = <{ to: string }>exportType.to.day;
      const mTo = <{ to: string }>exportType.to.month;
      const yTo = <{ to: string }>exportType.to.year;
      if (typeof yTo !== 'undefined' && typeof mTo !== 'undefined' && typeof dTo !== 'undefined') {
        exportType.to = yTo + '-' + mTo + '-' + dTo;
      }
    }
    this.exportType.entity === 'Emails' ? this.exportIt(exportType) : this.generateExportFile(exportType);
  }

  generateExportFile(exportType) {

    this.exportService.generateExcelFile(exportType).subscribe(resp => {
      const el: HTMLElement = this.downloadLink.nativeElement as HTMLElement;
      el.setAttribute('download', 'download');
      el.setAttribute('href', this.baseUrl + '/download?path=' + resp.path
        + '&filename=' + resp.name);
      el.click();
    });
  }

  exportIt(exportType) {
    const params = this.getExportItParams(exportType);
    this.orderService.exportOrders(params).subscribe(res => {
      const el: HTMLElement = this.downloadLink.nativeElement as HTMLElement;
      el.setAttribute('download', 'download');
      el.setAttribute('href', this.baseUrl + '/download?path=' + res.path
        + '&filename=' + res.name);
      el.click();
    });
  }

  getExportItParams(exportType): HttpParams {
    let params = new HttpParams();
    params = params.append('dealerProfile', this.selectedDealerProfile ? this.selectedDealerProfile.value : null);
    params = params.append('contactFunction', this.selectedContactFunction ? this.selectedContactFunction.value : null);
    params = params.append('q[from]', exportType.from ? exportType.from : null);
    params = params.append('q[to]', exportType.to ? exportType.to : null);
    params = params.append('q[invoiceStatus]', 'all');
    params = params.append('q[status]', 'all');
    params = params.append('q[language]', 'all');
    params = params.append('q[supplier_id]', 'all');
    params = params.append('q[collection_id]', 'all');
    params = params.append('q[dealer_id]', 'all');
    params = params.append('q[model_id]', 'all');
    params = params.append('sortType', 'desc');
    params = params.append('sortBy', 'id');
    params = params.append('filter', '%257B%257D');
    params = params.append('status', 'all');
    params = params.append('per_page', '25');
    params = params.append('query', '');
    params = params.append('page', '1');
    params = params.append('layout', 'layout5');
    return params;
  }
}
